const lecturerRoutes = [
  {
    path: '/lektor',
    redirect: '/admin/dashboard',
    component: () => import('@/views/Layouts/SidebarContent'),
    meta: {
      allowedUserTypes: ['lecturer']
    },
    children: [
      {
        path: 'dashboard',
        component: () => import('@/views/LecturerPanel/Dashboard/'),
        meta: {
          title: 'Dashboard'
        }
      },
      {
        path: 'profil',
        component: () => import('@/views/LecturerPanel/Profile/'),
        meta: {
          title: 'Mój profil'
        }
      },
      {
        path: 'aplikacje',
        component: () => import('@/views/LecturerPanel/Applications/'),
        meta: {
          title: 'Aplikacje'
        }
      },
      {
        path: 'kursy',
        component: () => import('@/views/LecturerPanel/Course/List/')
      },
      {
        path: 'kursy/szczegoly/:courseId',
        component: () => import('@/views/LecturerPanel/Course/Details/'),
        children: [
          {
            path: 'info',
            component: () =>
              import('@/views/LecturerPanel/Course/Details/Info/'),
            meta: {
              title: 'Informacje'
            }
          },
          {
            path: 'kalendarz',
            component: () =>
              import('@/views/LecturerPanel/Course/Details/Calendar/'),
            meta: {
              title: 'Kalendarz'
            }
          },
          {
            path: 'lektor',
            component: () =>
              import('@/views/LecturerPanel/Course/Details/Lecturer/'),
            meta: {
              title: 'Szczegóły lektora'
            }
          },
          {
            path: 'kursanci',
            component: () =>
              import('@/views/LecturerPanel/Course/Details/Students/'),
            meta: {
              title: 'Kursanci'
            }
          },
          {
            path: 'materialy-dydaktyczne',
            component: () =>
              import('@/views/LecturerPanel/Course/Details/Materials/'),
            meta: {
              title: 'Materiały dydaktyczne'
            },
            props: true
          },
          {
            path: 'historia-zajec',
            component: () =>
              import('@/views/LecturerPanel/Course/Details/History/'),
            props: true,
            meta: {
              title: 'Historia zajęć'
            }
          }
        ]
      },
      {
        path: 'biblioteka',
        component: () => import('@/views/LecturerPanel/Library/'),
        redirect: 'biblioteka/kursy',
        children: [
          {
            path: 'kursy',
            component: () =>
              import('@/views/LecturerPanel/Library/ForCoursesTab/'),
            meta: {
              title: 'Biblioteka dla kursów'
            }
          },
          {
            path: 'lektorzy',
            props: true,
            component: () =>
              import('@/views/LecturerPanel/Library/ForLecturersTab/'),
            meta: {
              title: 'Biblioteka dla lektorów'
            }
          }
        ]
      }
    ]
  }
]

export default lecturerRoutes
